import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { ConfigService } from '../_services/config.service';
import { ApiService } from '../_services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { AssessmentSelectorComponent } from '../assessment-selector/assessment-selector.component';

@Component({
  selector: 'true-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  standalone: false
})
export class HomeComponent {
  assessmentName: string = "/";
  assessmentObject: string = "";
    
  constructor(private router: Router, protected api: ApiService, public readonly config: ConfigService, private dialog: MatDialog,) { }
  
  ngOnInit(): void {
    this.api.getAssessment().subscribe((assessment) => {      
      if (assessment) {
        this.assessmentName = assessment.name;
        this.assessmentObject = assessment.object;
      }
    });    
  }

  navigate(id): void {
    this.router.navigate(['/'+id]);    
  }

  chooseAssessment(): void {
    let dialogRef = this.dialog.open(AssessmentSelectorComponent, {
      height: '765px',
      width: '800px',
    });

    dialogRef.beforeClosed().subscribe(() => {
      window.location.reload();
    });
  }

}
